import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ValuesList } from '../../../UI/ValuesList/ValuesList';
import { useTranslation } from 'react-i18next';

export const EstimateMainCalculation = () => {
    const manualCalculations = useSelector((state) => state.measurementsReducer.manualCalculations);

    const { t } = useTranslation();

    const values = useMemo(
        () => [
            {
                title: t('EstimateMainCalculation.values.title.floor_area'),
                type: 'floor_area',
                value: manualCalculations.floor_area,
                unit: t('MeasurementDoors.unit.area'),
            },
            {
                title: t('EstimateMainCalculation.values.title.ceiling_area'),
                type: 'ceiling_area',
                value: manualCalculations.ceiling_area,
                unit: t('MeasurementDoors.unit.area'),
            },
            {
                title: t('EstimateMainCalculation.values.title.perimeter'),
                type: 'perimeter',
                value: manualCalculations.perimeter,
                unit: t('MeasurementDoors.unit.perimeter'),
            },
            {
                title: t('EstimateMainCalculation.values.title.wall_area'),
                type: 'wall_area',
                value: manualCalculations.wall_area,
                unit: t('MeasurementDoors.unit.area'),
            },
            {
                title: t('EstimateMainCalculation.values.title.without_opening'),
                type: 'without_opening',
                value: manualCalculations.without_opening,
                unit: t('MeasurementDoors.unit.area'),
            },
            {
                title: t('EstimateMainCalculation.values.title.volume'),
                type: 'volume',
                value: manualCalculations.volume,
                unit: t('MeasurementDoors.unit.volume'),
            },
        ],
        [
            manualCalculations.floor_area,
            manualCalculations.ceiling_area,
            manualCalculations.perimeter,
            manualCalculations.wall_area,
            manualCalculations.without_opening,
            manualCalculations.volume,
        ]
    );

    return (
        <>
            {!!values.length && (
                <ValuesList
                    title={t('EstimateMainCalculation.return.ValuesList.title')}
                    values={values}
                />
            )}
        </>
    );
};
